import { IconButton, MenuItem, TableCell, TableRow, TextField, Tooltip } from "@mui/material"
import { Delete } from "@mui/icons-material"
import { Controller, useFormContext, useWatch } from "react-hook-form"
import { NodeTagsFormValues } from "@features/administration/products/EditProduct/NodeTagsForm/NodeTagsForm"
import { memo } from "react"

type TagRowProps = {
  index: number
  onDelete: (index: number) => void
}

const TagRow = (props: TagRowProps) => {
  const form = useFormContext<NodeTagsFormValues>()

  const tagTypeValue = useWatch({
    control: form.control,
    name: `rows.${props.index}.type`,
  })

  return (
    <TableRow>
      <TableCell>
        <strong>{props.index + 1}.</strong>
      </TableCell>
      <TableCell>
        <Controller
          control={form.control}
          name={`rows.${props.index}.name`}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </TableCell>

      <TableCell>
        <Controller
          control={form.control}
          name={`rows.${props.index}.type`}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              InputLabelProps={{ shrink: true }}
              select
              onChange={(e) => {
                field.onChange(e)
                if (e.target.value === "dropdown") return

                // for text type, clear the value and description fields
                form.setValue(`rows.${props.index}.value`, "", { shouldValidate: true })
                form.setValue(`rows.${props.index}.description`, "", { shouldValidate: true })
              }}
            >
              <MenuItem value="text">Text</MenuItem>
              <MenuItem value="dropdown">Dropdown</MenuItem>
            </TextField>
          )}
        />
      </TableCell>

      <TableCell>
        {tagTypeValue === "dropdown" && (
          <Controller
            control={form.control}
            name={`rows.${props.index}.value`}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        )}
      </TableCell>

      <TableCell>
        {tagTypeValue === "dropdown" && (
          <Controller
            control={form.control}
            name={`rows.${props.index}.description`}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        )}
      </TableCell>

      <TableCell>
        <Tooltip title="Delete" arrow>
          <IconButton color="error" onClick={() => props.onDelete(props.index)}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}

const MemoizedTagRow = memo(TagRow)

TagRow.displayName = "TagRow"

export default MemoizedTagRow
